import Vue from 'vue'
import VueRouter from 'vue-router'
import Player from '../views/Player.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'player',
    component: Player
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
